var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 22,
    viewBox: "0 0 266 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14458_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 5.5H19.2499",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 11H19.2499",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 16.5H19.2499",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.5H2.76",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11H2.76",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 16.5H2.76",
    stroke: "#5770C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8131 3L101.309 18.6098H99.7252L98.403 15.4326H91.2232L89.901 18.6098H88.3168L94.8131 3ZM91.8364 13.9592L94.8131 6.80654L97.7898 13.9592H91.8364Z",
    fill: "url(#paint0_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9363 18.9834C54.1995 18.9834 57.6554 15.4691 57.6554 11.1339C57.6554 6.79884 54.1995 3.28454 49.9363 3.28454C45.6731 3.28454 42.2172 6.79884 42.2172 11.1339C42.2172 15.4691 45.6731 18.9834 49.9363 18.9834ZM49.9363 15.465C52.2886 15.465 54.1955 13.5259 54.1955 11.1339C54.1955 8.74197 52.2886 6.80289 49.9363 6.80289C47.584 6.80289 45.6771 8.74197 45.6771 11.1339C45.6771 13.5259 47.584 15.465 49.9363 15.465Z",
    fill: "url(#paint1_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0494 3.6118H30V18.664H33.0494V12.4323L38.4012 18.664H42.2905L35.8271 11.1379L42.2905 3.6118H38.4012L33.0494 9.84351V3.6118Z",
    fill: "url(#paint2_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5475 3.6118H63.597V15.8011H69.2498V18.664H60.548L60.5475 3.6118Z",
    fill: "url(#paint3_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6216 18.8865C85.3025 18.8865 85.8545 18.3252 85.8545 17.6328C85.8545 16.9405 85.3025 16.3792 84.6216 16.3792C83.9407 16.3792 83.3887 16.9405 83.3887 17.6328C83.3887 18.3252 83.9407 18.8865 84.6216 18.8865Z",
    fill: "url(#paint4_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 18.6098L127.504 3L121.007 18.6098H122.592L123.914 15.4326H131.094L132.416 18.6098H134ZM127.504 6.80654L124.527 13.9592H130.48L127.504 6.80654Z",
    fill: "url(#paint5_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09 3.6118H117.635V18.6097H116.09V3.6118Z",
    fill: "url(#paint6_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6351 6.3118L77.9884 7.56369C77.5574 6.12279 75.3796 5.31856 74.3467 6.66413C73.3818 8.22048 74.8631 9.16938 77.4244 10.1353C79.9357 11.0823 80.8769 12.6009 80.9268 14.3433C80.9767 16.0858 80.0196 19.0335 75.611 18.9997C72.0842 18.9726 70.6035 16.5862 70.304 15.3964C70.7199 15.1991 71.8379 14.6825 72.9824 14.1953C73.9141 17.0881 77.6406 16.7667 77.8902 14.8382C78.0796 13.374 76.5853 12.8217 75.1429 12.2886C74.6079 12.0909 74.08 11.8958 73.6479 11.6578C71.7298 10.6014 71.1981 9.30269 71.086 8.00375C70.974 6.70481 71.3861 3.8952 75.3116 3.3326C78.3785 2.89305 80.1859 5.10815 80.6351 6.3118Z",
    fill: "url(#paint7_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.236 6.29962L111.678 5.59871C111.085 4.28108 109.439 3.12057 107.368 3.42201C104.256 3.87477 103.845 6.49698 103.941 7.78773C104.036 9.07849 104.573 10.099 106.32 11.0865C106.643 11.2691 107.048 11.4387 107.482 11.6199C108.938 12.228 110.707 12.9671 110.707 14.7687C110.707 18.1521 105.666 18.1057 104.872 15.2311C104.415 15.4581 104.147 15.5853 103.954 15.6765C103.736 15.78 103.615 15.8374 103.426 15.9416C103.681 17.1239 105.19 18.8682 107.735 18.8682C111.312 18.8682 112.229 16.3406 112.186 14.6092C112.144 12.8777 111.166 11.6762 109.026 10.7351L108.879 10.6703C106.761 9.74054 105.006 8.96981 105.575 6.54208C106.058 4.48324 109.381 4.26852 110.236 6.29962Z",
    fill: "url(#paint8_linear_14458_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.241 11.4091C152.241 12.5194 152.031 13.464 151.61 14.2429C151.192 15.0218 150.622 15.6167 149.9 16.0277C149.181 16.4354 148.372 16.6392 147.474 16.6392C146.569 16.6392 145.757 16.4337 145.038 16.0227C144.318 15.6117 143.75 15.0168 143.332 14.2379C142.915 13.459 142.706 12.5161 142.706 11.4091C142.706 10.2988 142.915 9.35417 143.332 8.57528C143.75 7.7964 144.318 7.20312 145.038 6.79545C145.757 6.38447 146.569 6.17898 147.474 6.17898C148.372 6.17898 149.181 6.38447 149.9 6.79545C150.622 7.20312 151.192 7.7964 151.61 8.57528C152.031 9.35417 152.241 10.2988 152.241 11.4091ZM150.059 11.4091C150.059 10.6899 149.951 10.0833 149.736 9.58949C149.524 9.09564 149.224 8.72112 148.836 8.46591C148.448 8.2107 147.994 8.0831 147.474 8.0831C146.953 8.0831 146.499 8.2107 146.112 8.46591C145.724 8.72112 145.422 9.09564 145.207 9.58949C144.995 10.0833 144.888 10.6899 144.888 11.4091C144.888 12.1283 144.995 12.7348 145.207 13.2287C145.422 13.7225 145.724 14.0971 146.112 14.3523C146.499 14.6075 146.953 14.7351 147.474 14.7351C147.994 14.7351 148.448 14.6075 148.836 14.3523C149.224 14.0971 149.524 13.7225 149.736 13.2287C149.951 12.7348 150.059 12.1283 150.059 11.4091ZM153.836 16.5V6.31818H157.853C158.625 6.31818 159.283 6.46567 159.827 6.76065C160.37 7.05232 160.785 7.45833 161.07 7.97869C161.358 8.49574 161.502 9.09233 161.502 9.76847C161.502 10.4446 161.356 11.0412 161.065 11.5582C160.773 12.0753 160.351 12.478 159.797 12.7663C159.247 13.0547 158.581 13.1989 157.798 13.1989H155.238V11.4737H157.45C157.865 11.4737 158.206 11.4025 158.475 11.2599C158.746 11.1141 158.949 10.9136 159.081 10.6584C159.217 10.3999 159.285 10.1032 159.285 9.76847C159.285 9.4304 159.217 9.13542 159.081 8.88352C158.949 8.62831 158.746 8.43111 158.475 8.2919C158.203 8.14938 157.858 8.07812 157.441 8.07812H155.989V16.5H153.836ZM162.901 16.5V6.31818H169.761V8.09304H165.053V10.5192H169.408V12.294H165.053V14.7251H169.781V16.5H162.901ZM171.473 16.5V6.31818H175.49C176.259 6.31818 176.915 6.45573 177.459 6.73082C178.006 7.0026 178.421 7.38873 178.706 7.8892C178.995 8.38636 179.139 8.97135 179.139 9.64418C179.139 10.3203 178.993 10.902 178.702 11.3892C178.41 11.8731 177.987 12.2443 177.434 12.5028C176.884 12.7614 176.217 12.8906 175.435 12.8906H172.746V11.1605H175.087C175.498 11.1605 175.84 11.1042 176.111 10.9915C176.383 10.8788 176.585 10.7098 176.718 10.4844C176.854 10.259 176.922 9.97893 176.922 9.64418C176.922 9.30611 176.854 9.02107 176.718 8.78906C176.585 8.55705 176.381 8.38139 176.106 8.26207C175.835 8.13944 175.492 8.07812 175.077 8.07812H173.626V16.5H171.473ZM176.971 11.8665L179.502 16.5H177.126L174.65 11.8665H176.971ZM182.415 16.5H180.108L183.623 6.31818H186.398L189.907 16.5H187.601L185.05 8.64489H184.971L182.415 16.5ZM182.271 12.4979H187.72V14.1783H182.271V12.4979ZM189.501 8.09304V6.31818H197.863V8.09304H194.746V16.5H192.618V8.09304H189.501ZM201.393 6.31818V16.5H199.24V6.31818H201.393ZM212.521 11.4091C212.521 12.5194 212.31 13.464 211.889 14.2429C211.472 15.0218 210.902 15.6167 210.179 16.0277C209.46 16.4354 208.651 16.6392 207.753 16.6392C206.848 16.6392 206.036 16.4337 205.317 16.0227C204.598 15.6117 204.029 15.0168 203.612 14.2379C203.194 13.459 202.985 12.5161 202.985 11.4091C202.985 10.2988 203.194 9.35417 203.612 8.57528C204.029 7.7964 204.598 7.20312 205.317 6.79545C206.036 6.38447 206.848 6.17898 207.753 6.17898C208.651 6.17898 209.46 6.38447 210.179 6.79545C210.902 7.20312 211.472 7.7964 211.889 8.57528C212.31 9.35417 212.521 10.2988 212.521 11.4091ZM210.338 11.4091C210.338 10.6899 210.231 10.0833 210.015 9.58949C209.803 9.09564 209.503 8.72112 209.115 8.46591C208.727 8.2107 208.273 8.0831 207.753 8.0831C207.233 8.0831 206.779 8.2107 206.391 8.46591C206.003 8.72112 205.701 9.09564 205.486 9.58949C205.274 10.0833 205.168 10.6899 205.168 11.4091C205.168 12.1283 205.274 12.7348 205.486 13.2287C205.701 13.7225 206.003 14.0971 206.391 14.3523C206.779 14.6075 207.233 14.7351 207.753 14.7351C208.273 14.7351 208.727 14.6075 209.115 14.3523C209.503 14.0971 209.803 13.7225 210.015 13.2287C210.231 12.7348 210.338 12.1283 210.338 11.4091ZM222.632 6.31818V16.5H220.772L216.343 10.0916H216.268V16.5H214.115V6.31818H216.005L220.4 12.7216H220.489V6.31818H222.632ZM227.263 8.09304V6.31818H235.625V8.09304H232.508V16.5H230.38V8.09304H227.263ZM245.894 11.4091C245.894 12.5194 245.683 13.464 245.262 14.2429C244.845 15.0218 244.275 15.6167 243.552 16.0277C242.833 16.4354 242.024 16.6392 241.126 16.6392C240.221 16.6392 239.409 16.4337 238.69 16.0227C237.971 15.6117 237.402 15.0168 236.985 14.2379C236.567 13.459 236.358 12.5161 236.358 11.4091C236.358 10.2988 236.567 9.35417 236.985 8.57528C237.402 7.7964 237.971 7.20312 238.69 6.79545C239.409 6.38447 240.221 6.17898 241.126 6.17898C242.024 6.17898 242.833 6.38447 243.552 6.79545C244.275 7.20312 244.845 7.7964 245.262 8.57528C245.683 9.35417 245.894 10.2988 245.894 11.4091ZM243.711 11.4091C243.711 10.6899 243.604 10.0833 243.388 9.58949C243.176 9.09564 242.876 8.72112 242.488 8.46591C242.1 8.2107 241.646 8.0831 241.126 8.0831C240.606 8.0831 240.152 8.2107 239.764 8.46591C239.376 8.72112 239.074 9.09564 238.859 9.58949C238.647 10.0833 238.541 10.6899 238.541 11.4091C238.541 12.1283 238.647 12.7348 238.859 13.2287C239.074 13.7225 239.376 14.0971 239.764 14.3523C240.152 14.6075 240.606 14.7351 241.126 14.7351C241.646 14.7351 242.1 14.6075 242.488 14.3523C242.876 14.0971 243.176 13.7225 243.388 13.2287C243.604 12.7348 243.711 12.1283 243.711 11.4091ZM256.845 11.4091C256.845 12.5194 256.635 13.464 256.214 14.2429C255.796 15.0218 255.226 15.6167 254.503 16.0277C253.784 16.4354 252.975 16.6392 252.077 16.6392C251.172 16.6392 250.36 16.4337 249.641 16.0227C248.922 15.6117 248.354 15.0168 247.936 14.2379C247.518 13.459 247.309 12.5161 247.309 11.4091C247.309 10.2988 247.518 9.35417 247.936 8.57528C248.354 7.7964 248.922 7.20312 249.641 6.79545C250.36 6.38447 251.172 6.17898 252.077 6.17898C252.975 6.17898 253.784 6.38447 254.503 6.79545C255.226 7.20312 255.796 7.7964 256.214 8.57528C256.635 9.35417 256.845 10.2988 256.845 11.4091ZM254.662 11.4091C254.662 10.6899 254.555 10.0833 254.339 9.58949C254.127 9.09564 253.827 8.72112 253.439 8.46591C253.052 8.2107 252.598 8.0831 252.077 8.0831C251.557 8.0831 251.103 8.2107 250.715 8.46591C250.327 8.72112 250.026 9.09564 249.81 9.58949C249.598 10.0833 249.492 10.6899 249.492 11.4091C249.492 12.1283 249.598 12.7348 249.81 13.2287C250.026 13.7225 250.327 14.0971 250.715 14.3523C251.103 14.6075 251.557 14.7351 252.077 14.7351C252.598 14.7351 253.052 14.6075 253.439 14.3523C253.827 14.0971 254.127 13.7225 254.339 13.2287C254.555 12.7348 254.662 12.1283 254.662 11.4091ZM258.44 16.5V6.31818H260.592V14.7251H264.957V16.5H258.44Z",
    fill: "#5770C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14458_165",
    x1: 20.8308,
    y1: 3,
    x2: 134,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367524,
    stopColor: "#7D62EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716242,
    stopColor: "#628FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988197,
    stopColor: "#57AEF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14458_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsLogo);
export default __webpack_public_path__ + "static/media/ops-logo.43eb303bfa5b61fe88ead715b341073c.svg";
export { ForwardRef as ReactComponent };